import styles from './SearchTray.module.css';
import type { RecentSearch } from '../../hooks/useRecentSearches';

export interface RecentSearchesListProps {
  items: RecentSearch[];
  onActivate: (query: string) => void;
  onRemove: (query: string) => void;
  onClearAll: () => void;
}

export function RecentSearchesList({ items, onActivate, onRemove, onClearAll }: RecentSearchesListProps) {
  if (items.length === 0) return null;
  return (
    <div className={styles.group}>
      <div className={styles.groupLabel} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Recent</span>
        <button type="button" className={styles.recentClearBtn} onClick={onClearAll} aria-label="Clear all recent searches">
          Clear
        </button>
      </div>
      {items.map((it) => (
        <div key={it.query} className={styles.recentRow} onClick={() => onActivate(it.query)} role="button" tabIndex={0}>
          <span className={styles.recentLabel}>{it.query}</span>
          <button
            type="button"
            className={styles.recentRemove}
            aria-label={`Remove "${it.query}" from recent`}
            onClick={(e) => {
              e.stopPropagation();
              onRemove(it.query);
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
